//#region COMPONENTS
import TodaysEventsCircle from '../TodaysEventsCircle/TodaysEventsCircle';
//#endregion

//#region UTILS
import { MonthLongStrings } from '../../../core/constants';
import { groupBy } from '../../../tools';
import { useTranslation } from "react-i18next";
//#endregion

//#region STYLES
import './TodaysEvents.scss';
//#endregion

export default function TodaysEvents({ todayEvents }: any) {
    //TRANSLATION INIT
    const { t } = useTranslation();

    // GET CURRENT TIMESTAMP
    const timestamp = () => {
        const today = new Date();
        const day = today.getDate();
        const month = MonthLongStrings[today.getMonth()];
        const year = today.getFullYear();
        const time = today.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

        return `${day} ${month} ${year}, ${time}`;
    }

    // GROUP THE EVENTS BY PRIORITY
    const categorys = ["Suspicious Activity", "High CO2 Levels", "Low Humidity", "High Humidity", "High Gas/Smoke", "Low Temperature", "High Temperature"]
    console.log('todayEvents: ', todayEvents);

    //todayEvents = todayEvents.length > 0 ? todayEvents?.filter((f) => categorys.includes(f.category)) : {};
    todayEvents = Object.keys(todayEvents).length > 0 ? groupBy(todayEvents, 'priority') : {};

    // IF THERE ARE EVENTS SHOW THEM
    // ELSE SHOW THE DEFAULT EMPTY OUTPUT
    return (
        <div className='TodaysEvents'>
            <h2 className='TodaysEvents__title'>{t("dashboard.todayEvents")}</h2>
            <div className='TodaysEvents__data'>
                <p className='TodaysEvents__timestamp'>{t("dashboard.as")} {timestamp()}</p>
                <div className='TodaysEvents__events'>
                    <div className='TodaysEvents__events-low'>
                        <TodaysEventsCircle size={'158px'}
                            value={(Number(todayEvents["3 - Medium"]?.length ?? 0) + Number(todayEvents["4 - Medium Low"]?.length ?? 0) + Number(todayEvents["5 - Low"]?.length ?? 0))}
                            text={t("dashboard.lowEvents")}
                            color={'255, 193, 7'} />
                    </div>
                    <div className='TodaysEvents__events-medium'>
                        <TodaysEventsCircle size={'158px'}
                            value={todayEvents["2 - Medium High"]?.length ?? 0}
                            text={t("dashboard.mediumEvents")}
                            color={'255, 129, 0'} />
                    </div>
                    <div className='TodaysEvents__events-high'>
                        <TodaysEventsCircle size={'158px'}
                            value={todayEvents["1 - High"]?.length ?? 0}
                            text={t("dashboard.highEvents")}
                            color={'229, 57, 53'} />
                    </div>
                </div>
            </div>
        </div>
    );
}